import { Badge } from '@chakra-ui/react';

import { isNotDefined } from '@enterprise/core';
import { DefaultToolTip } from '@enterprise/ui';

import type { ApproachCellProps } from './types/approach-cell.props';

const APPROACH_CONFIG = {
  'dropped-by-twentile': { colorScheme: 'purple', label: 'Dropped by Twentile' },
  manual: { colorScheme: 'orange', label: 'Manual' },
  'not-set': { colorScheme: 'gray', label: 'Not set' },
} as const;

const ApproachCell = ({ data }: ApproachCellProps) => {
  if (isNotDefined(data)) {
    return null;
  }

  const config = APPROACH_CONFIG[data.approach];

  return (
    <DefaultToolTip label={config.label}>
      <Badge
        colorScheme={config.colorScheme}
        fontSize="xs"
        isTruncated
        lineHeight="initial!"
        px={3}
        py={1}
        rounded="lg">
        {config.label}
      </Badge>
    </DefaultToolTip>
  );
};

export default ApproachCell;
